import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(null);

  const navigationItems = [
    {
      id: 'home',
      path: '/',
      title: 'Home',
      subtitle: 'Welcome to my world',
      icon: '🏠'
    },
    {
      id: 'blog',
      path: '/blog',
      title: 'Blog',
      subtitle: 'Thoughts and insights',
      icon: '📝'
    },
    {
      id: 'work',
      path: '/work',
      title: 'Work',
      subtitle: 'Professional journey',
      icon: '💼'
    },
    {
      id: 'life',
      path: '/life',
      title: 'Life',
      subtitle: 'Personal interests',
      icon: '🌟'
    },
    {
      id: 'contact',
      path: '/contact',
      title: 'Contact',
      subtitle: 'Get in touch',
      icon: '📬'
    }
  ];

  return (
    <div className="fixed top-0 left-0 h-screen flex flex-col justify-center p-4 z-50">
      <div className="relative">
        <div className="absolute -left-4 top-1/2 -translate-y-1/2 w-1 h-16 bg-gradient-to-b from-blue-500 to-purple-500 rounded-full" />
        
        <div className="space-y-2">
          {navigationItems.map((item) => (
            <motion.div
              key={item.id}
              onHoverStart={() => setIsHovered(item.id)}
              onHoverEnd={() => setIsHovered(null)}
              className="relative"
            >
              <motion.button
                onClick={() => navigate(item.path)}
                className={`
                  flex items-center gap-3 px-4 py-2 rounded-lg transition-all
                  ${location.pathname === item.path 
                    ? 'text-white bg-white/10' 
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }
                `}
              >
                <span className="text-xl">{item.icon}</span>
                <AnimatePresence>
                  {isHovered === item.id && (
                    <motion.div
                      initial={{ opacity: 0, x: -10 }}
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -10 }}
                      className="absolute left-full ml-4 whitespace-nowrap"
                    >
                      <div className="bg-black/90 backdrop-blur-sm px-4 py-2 rounded-lg border border-gray-800">
                        <div className="text-white font-medium">{item.title}</div>
                        <div className="text-sm text-gray-400">{item.subtitle}</div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.button>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Navigation;
